import request from './request'

/**
 * 【已移除】自助充值 recharge(amount) → POST /user/recharge
 *
 * 原实现是「客户端直接加余额」，零支付校验 —— 登录用户点一下就能白拿积分。
 * 平台尚未接入支付，这条链路已整体关闭：
 *   · 后端 /user/recharge 直接返回 403（见 UserCenterController.recharge）
 *   · 前端不留调用入口，页面改为提示「请联系客服充值」
 *   · 充值由管理员在后台操作（POST /admin/customerRecharge，有权限校验 + 流水）
 * 将来接入支付时，恢复成「下单 → 支付回调（验签）→ 到账」，不要恢复成本函数。
 */

/** 积分余额+规则 */
export function fetchBalance() {
  return request.get('/user/balance')
}

/** 预估本次生成消耗（模型由后端按参数选，前端只展示积分） */
export function estimateImage(params = {}) {
  return request.post('/user/estimateImage', null, { params })
}

/** 积分明细（消费/充值） */
export function fetchTransactions(params = {}) {
  return request.get('/user/transactions', { params })
}

/** 充值记录 */
export function fetchRecharges(params = {}) {
  return request.get('/user/recharges', { params })
}

/** 公开积分规则 */
export function fetchRules() {
  return request.get('/user/rules')
}
